import {
  PageFilterChipsSkeleton,
  PageSearchFilterRowSkeleton,
  PageTabsSkeleton
} from '@/shared/ui/Skeleton'

export const ScheduleStickySkeleton = () => (
  <div className="flex flex-col gap-2" aria-hidden>
    <PageTabsSkeleton count={3} />
    <PageSearchFilterRowSkeleton />
    <PageFilterChipsSkeleton count={4} />
  </div>
)
